<template>
  <div class="recruitment-contents">
    <div>
      <b-row>
        <b-colxx xxs="12">
          <div class="separator mb-5"></div>
        </b-colxx>
      </b-row>
      <!-- Study dropdown groups -->
      <b-row>
        <b-colxx xxs="12" class="mb-4 pl-0">
          <header-drop-down-filter
            :leftHeaderText="leftHeaderTextValue"
            :sites="allSitesList"
            :countries="countryList"
            :checkedSitesApply="sitesSelected == 'all' ? allSitesList : sitesSelected"
            :checkedCountriesApply="countrySelected == 'all' ? countryList : countrySelected"
            :participants="[]"
            :exportBtn="true"
            :participantsBtn="false"
            :todayDate="todaysDate"
            @onApplyCountry="getDataFromCountry"
            @onApplySites="getDataFromSite"
            @onApplyFpi="filter"
            :dataPicker="dataPicker"
            @onApplyRangeMonth="getRangeMonth"
            v-if="studyData"
            :specificSiteId="specificSiteId"
            :zoomGraphValue="zoomGraphValue"
            :toggleFeatures="toggleFeatures"
            :studyData="studyData"
          ></header-drop-down-filter>
        </b-colxx>
      </b-row>
      <div v-if="zoomGraphValue" @click="zoomGraphValue = ''" class="mb-10 color_4c8ce4 expand-back">
        <i class="fa fa-caret-left" aria-hidden="true"></i>
        Back
      </div>
      <!-- Top cards -->
      <b-row v-if="zoomGraphValue == '' && specificSiteId && specificSiteId.length === 0" class="pb-10">
        <b-colxx xl="3" lg="12" md="12" class="pl-0 pb-6">
          <b-card class="custom-card white-bg">
            <b-card-header>
              <div class="card-text-strong" title="Total Sites with FPI">
                Total Sites with FPI
              </div>
            </b-card-header>
            <div class="data-card-center">
              <div class="number-text">
                {{ totalFpiSites }}
              </div>
            </div>
          </b-card>
        </b-colxx>
        <b-colxx xl="3" lg="12" md="12" class="pl-0 pb-6">
          <b-card class="custom-card white-bg">
            <b-card-header>
              <div class="card-text-strong" title="Total Sites with Data In">
                Total Sites with Data In
              </div>
            </b-card-header>
            <div class="data-card-center">
              <div class="number-text">
                {{ totalFirstDataSites }}
              </div>
            </div>
          </b-card>
        </b-colxx>
        <b-colxx xl="3" lg="12" md="12" class="pl-0 pb-6">
          <!-- Fastest FPI -->
          <b-card class="custom-card white-bg">
            <b-card-header>
              <div class="card-text-strong" title="Fastest Sites to First-Participant-In">
                Site with First Participant In
              </div>
            </b-card-header>
            <div class="align-start pb-6 pt-6 data-cards" v-if="fastestFpiSiteCountry !== null && fastestFpiSiteCountry !== ''">
              <div class="card-text-subtitle">
                <span class="small-card-text">Site</span>
                <span class="add-tooltip">{{ fastestFpiSiteCountry ? fastestFpiSiteCountry.site : "" }}</span>
                <div class="custom-tooltip hidden-text-custom">
                  <div>
                    {{ fastestFpiSiteCountry ? fastestFpiSiteCountry.site : "" }}
                  </div>
                </div>
              </div>
              <div class="card-text-subtitle">
                <span class="small-card-text">Country</span>
                <span class="add-tooltip">{{ fastestFpiSiteCountry ? fastestFpiSiteCountry.country : "" }}</span>
                <div class="custom-tooltip hidden-text-custom">
                  <div>
                    {{ fastestFpiSiteCountry ? fastestFpiSiteCountry.country : "" }}
                  </div>
                </div>
              </div>
              <div class="card-text-subtitle">
                <span class="small-card-text">Active Date</span>
                <span>{{ fastestFpiDateBegin }}</span>
              </div>
              <div class="card-text-subtitle">
                <span class="small-card-text">FPI Date</span>
                <span>{{ fastestFpiDateEnd }}</span>
              </div>
            </div>
            <div v-else class="align-center">
              <div class="card-text-title no-data" v-if="dataLoaded">
                No Data In
              </div>
            </div>
          </b-card>
        </b-colxx>
        <b-colxx xl="3" lg="12" md="12" class="pl-0 pb-6">
          <!-- Fastest First Data -->
          <b-card class="custom-card white-bg">
            <b-card-header>
              <div class="card-text-strong" title="Fastest Sites to First-Data-In">
                Site with Fastest First Data In
              </div>
            </b-card-header>
            <div class="align-start pb-6 pt-6 data-cards" v-if="fastestFirstDataSiteCountry !== null && fastestFirstDataSiteCountry !== ''">
              <div class="card-text-subtitle">
                <span class="small-card-text">Site</span>
                <span class="add-tooltip">{{ fastestFirstDataSiteCountry ? fastestFirstDataSiteCountry.site : "" }}</span>
                <div class="custom-tooltip hidden-text-custom">
                  <div>
                    {{ fastestFirstDataSiteCountry ? fastestFirstDataSiteCountry.site : "" }}
                  </div>
                </div>
              </div>
              <div class="card-text-subtitle">
                <span class="small-card-text">Country</span>
                <span class="add-tooltip">{{ fastestFirstDataSiteCountry ? fastestFirstDataSiteCountry.country : "" }}</span>
                <div class="custom-tooltip hidden-text-custom">
                  <div>
                    {{ fastestFirstDataSiteCountry ? fastestFirstDataSiteCountry.country : "" }}
                  </div>
                </div>
              </div>
              <div class="card-text-subtitle">
                <span class="small-card-text">Active Date</span>
                <span>{{ fastestFirstDataDateBegin }}</span>
              </div>
              <div class="card-text-subtitle">
                <span class="small-card-text">First Data Date</span>
                <span>{{ fastestFirstDataDateEnd }}</span>
              </div>
            </div>
            <div v-else class="align-center">
              <div class="card-text-title no-data" v-if="dataLoaded">
                No Data In
              </div>
            </div>
          </b-card>
        </b-colxx>
      </b-row>

      <b-row class="pb-10" v-show="zoomGraphValue == '' || zoomGraphValue == 'enrollment-sum'">
        <b-colxx xl="12" lg="12" md="12" class="pl-0" style="transition-duration: 0.2s" :class="zoomGraphValue === 'enrollment-sum' ? 'enrollment-sum-zoom' : ''">
          <enrollment-sum
            containerId="enrollmentSum"
            :rawData="enrollRawData"
            :zoomGraphValue="zoomGraphValue"
            :specificSiteId="specificSiteId"
            titleChart="Study Enrollment Progress PPM (Participants per Month)"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :studyId="studyId"
            :fromDate="fromDate"
            :toDate="toDate"
            :monthSelected="monthSelected"
            v-on:zoomEnabled="zoomGraphValue = 'enrollment-sum'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :dataLoaded="dataLoaded['overallEnrollmentData'] || false"
          ></enrollment-sum>
        </b-colxx>
      </b-row>
      <!-- Below line for RBAC: Non Site Roles-->
      <b-row v-if="specificSiteId && specificSiteId.length === 0" class="pb-10">
        <b-colxx :class="zoomGraphValue === 'top-5-enroll' ? 'col-xl-12 top-5-enroll-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 0.2s" v-show="zoomGraphValue == '' || zoomGraphValue == 'top-5-enroll'">
          <enrollment-sum-data containerId="blank" class="econsent-card" :topFiveCountries="topFiveCountries" :topFiveSites="topFiveSites" :dataLoaded="dataLoaded['overallEnrollmentData'] || false" v-on:zoomEnabled="zoomGraphValue = 'top-5-enroll'" v-on:zoomDisabled="zoomGraphValue = ''"></enrollment-sum-data>
        </b-colxx>

        <b-colxx :class="zoomGraphValue === 'econsent-quiz-completion' ? 'col-xl-12 consent-chart-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 0.2s" v-show="zoomGraphValue == '' || zoomGraphValue == 'econsent-quiz-completion'">
          <consent-apex-chart-card
            :vis="quizComprehension"
            containerId="quizCompleteContainer"
            class="econsent-card"
            titleChart="eConsent Comprehension Quiz Completion"
            scallabelX="% Completed"
            scallabelY="% Incomplete"
            :annotation="quizAnnotation"
            :specificSiteId="specificSiteId"
            :tooltipCallbacks="tooltipsParticipantQuizOptions"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'econsent-quiz-completion'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :dataLoaded="dataLoaded['visualizationRawDataQuiz'] || false"
          />
        </b-colxx>
      </b-row>
      <!-- End line for RBAC: Non Site Roles-->

      <!-- Below line for RBAC: Site Roles-->
      <b-row v-else class="pb-10">
        <b-colxx :class="zoomGraphValue == 'econsent-quiz-completion' ? 'col-xl-12 consent-chart-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 0.2s" v-show="zoomGraphValue == '' || zoomGraphValue == 'econsent-quiz-completion'">
          <consent-apex-chart-card
            :vis="quizComprehension"
            containerId="quizCompleteContainer"
            class="econsent-card"
            titleChart="eConsent Comprehension Quiz Completion"
            scallabelX="% Completed"
            scallabelY="% Incomplete"
            :annotation="quizAnnotation"
            :specificSiteId="specificSiteId"
            :tooltipCallbacks="tooltipsParticipantQuizOptions"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'econsent-quiz-completion'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :dataLoaded="dataLoaded['visualizationRawDataQuiz'] || false"
          />
        </b-colxx>
        <b-colxx :class="zoomGraphValue == 'site-active-fpfv' ? 'col-xl-12 site-active-fpfv-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 0.2s" v-show="zoomGraphValue == '' || zoomGraphValue == 'site-active-fpfv'">
          <!-- Timeline chart -->
          <apex-bar-chart-card :vis="fpiDataForViz" containerId="site-active-fpfv" title="Site Activation to First Participant First Visit" :zoomGraphValue="zoomGraphValue" :specificSiteId="specificSiteId" v-on:zoomEnabled="zoomGraphValue = 'site-active-fpfv'" v-on:zoomDisabled="zoomGraphValue = ''" :dataLoaded="dataLoaded['visualizationRawData'] || false"></apex-bar-chart-card>
        </b-colxx>
      </b-row>
      <!-- End line for RBAC: Site Roles-->

      <!-- Below line for RBAC: Non Site Roles-->
      <!-- TODO HIDE THIS UNTIL NEXT RELEASE  -->
      <b-row class="pb-10" v-if="getActivateScreenFailure">
        <b-colxx :class="zoomGraphValue == 'site-active-sfa' ? 'col-xl-12 site-active-sfa-zoom' : 'col-xl-12'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 0.2s" v-show="zoomGraphValue == '' || zoomGraphValue == 'site-active-sfa'">
          <ScreenFailureContainer
            containerId="site-active-sfa"
            title="Screen Failure Reasons"
            :zoomGraphValue="zoomGraphValue"
            :specificSiteId="specificSiteId"
            :vis="failureAggregation"
            v-on:zoomEnabled="zoomGraphValue = 'site-active-sfa'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :studyId="studyId"
            :dataLoaded="this.dataLoaded['visScreenFailure'] || false"
            :checkedSitesApply="sitesSelected == 'all' ? allSitesList : sitesSelected"
            :checkedCountriesApply="countrySelected == 'all' ? countryList : countrySelected"
          ></ScreenFailureContainer>
        </b-colxx>
      </b-row>

      <!-- End line for RBAC: Site Roles-->

      <!-- Below line for RBAC: Non Site Roles-->
      <b-row v-if="specificSiteId && specificSiteId.length === 0" class="pb-10">
        <b-colxx :class="zoomGraphValue == 'site-active-fpfv' ? 'col-xl-12 site-active-fpfv-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 0.2s" v-show="zoomGraphValue == '' || zoomGraphValue == 'site-active-fpfv'">
          <!-- Timeline chart -->
          <apex-bar-chart-card :vis="fpiDataForViz" containerId="site-active-fpfv" title="Site Activation to First Participant First Visit" :zoomGraphValue="zoomGraphValue" :specificSiteId="specificSiteId" v-on:zoomEnabled="zoomGraphValue = 'site-active-fpfv'" v-on:zoomDisabled="zoomGraphValue = ''" :dataLoaded="dataLoaded['visualizationRawData'] || false"></apex-bar-chart-card>
        </b-colxx>
        <b-colxx :class="zoomGraphValue == 'site-active-fdr' ? 'col-xl-12 site-active-fdr-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6 zoom_graph" style="transition-duration: 0.2s" v-show="zoomGraphValue == '' || zoomGraphValue == 'site-active-fdr'">
          <!-- Bar chart -->
          <apex-bar-chart-card :vis="firstDataDataForViz" containerId="site-active-fdr" title="Site Activation to First Data Received" :zoomGraphValue="zoomGraphValue" :specificSiteId="specificSiteId" v-on:zoomEnabled="zoomGraphValue = 'site-active-fdr'" v-on:zoomDisabled="zoomGraphValue = ''" :dataLoaded="dataLoaded['visualizationRawData'] || false"></apex-bar-chart-card>
        </b-colxx>
      </b-row>
      <!-- END line for RBAC: Non Site Roles-->

      <!-- Below line for RBAC: Site Roles-->
      <b-row v-else class="pb-10">
        <b-colxx :class="zoomGraphValue == 'site-active-fdr' ? 'col-xl-12 site-active-fdr-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6 zoom_graph" style="transition-duration: 0.2s" v-show="zoomGraphValue == '' || zoomGraphValue == 'site-active-fdr'">
          <!-- Bar chart -->
          <apex-bar-chart-card :vis="firstDataDataForViz" containerId="site-active-fdr" title="Site Activation to First Data Received" :zoomGraphValue="zoomGraphValue" :specificSiteId="specificSiteId" v-on:zoomEnabled="zoomGraphValue = 'site-active-fdr'" v-on:zoomDisabled="zoomGraphValue = ''" :dataLoaded="dataLoaded['visualizationRawData'] || false"> </apex-bar-chart-card>
        </b-colxx>
      </b-row>
      <!-- End line for RBAC: Site Roles-->

      <!-- kpi 4 newly implemeted -->
      <b-row class="pb-10">
        <b-colxx :class="zoomGraphValue == 'consent-disposition' ? 'col-xl-12 consent-disposition-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-10" style="transition-duration: 0.2s" v-show="zoomGraphValue == '' || zoomGraphValue == 'consent-disposition'">
          <eConsentDisposition
            containerId="blank"
            title="Consent Disposition"
            :zoomGraphValue="zoomGraphValue"
            :specificSiteId="specificSiteId"
            :vis="eConsentDispositionData"
            v-on:zoomEnabled="zoomGraphValue = 'consent-disposition'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :studyId="studyId"
            :dataLoaded="this.dataLoaded['visConsentDisposition'] || false"
            :checkedSitesApply="sitesSelected == 'all' ? allSitesList : sitesSelected"
            :checkedCountriesApply="countrySelected == 'all' ? countryList : countrySelected"
          ></eConsentDisposition>
        </b-colxx>
        <!-- kpi 4 newly implemeted end-->

        <!-- kpi 4 boxes in 2x2 manner -->
        <b-colxx v-show="zoomGraphValue === ''" xl="6" lg="6" md="12" class="pl-0 pb-0 pr-0">
          <b-row class="">
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-20">
              <b-card class="custom-card white-bg">
                <b-card-header>
                  <div class="card-text-strong" title="Most eConsents">
                    Most eConsents
                  </div>
                </b-card-header>
                <div v-if="consentBlocks.mostEconsent" class="data-card-center consent-height">
                  <div class="number-text " :style="{ color: getPrimaryColor() }">
                    {{ consentBlocks.mostEconsent }}
                  </div>
                  <div :style="{ color: getPrimaryColor() }">
                    {{ consentBlocks.mostEconsentSite }}
                  </div>
                </div>
                <div v-else class=".thread-consent-ct1 recruitment-doughnut-container align-center no-consent-height">
                  <div class="card-text-title no-data" v-if="this.dataLoaded['visConsentDisposition'] || false">
                    No Data In
                  </div>
                </div>
              </b-card>
            </b-colxx>
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-20">
              <b-card class="custom-card white-bg">
                <b-card-header>
                  <div class="card-text-strong" title="Most eConsents by Percentage">
                    Most eConsents by Percentage
                  </div>
                </b-card-header>
                <div v-if="consentBlocks.mostEconsent" class="data-card-center consent-height">
                  <div class="number-text " :style="{ color: getPrimaryColor() }">{{ consentBlocks.mostEconsentPercentage }}%</div>
                  <div :style="{ color: getPrimaryColor() }">
                    {{ consentBlocks.mostEconsentSite }}
                  </div>
                </div>
                <div v-else class=".thread-consent-ct1 recruitment-doughnut-container align-center no-consent-height">
                  <div class="card-text-title no-data" v-if="this.dataLoaded['visConsentDisposition'] || false">
                    No Data In
                  </div>
                </div>
              </b-card>
            </b-colxx>
          </b-row>
          <b-row>
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-10">
              <b-card class="custom-card white-bg">
                <b-card-header>
                  <div class="card-text-strong" title="Most Uploaded">
                    Most Uploaded
                  </div>
                </b-card-header>
                <div v-if="consentBlocks.mostUploaded" class="data-card-center consent-height">
                  <div class="number-text" :style="{ color: getPrimaryColor() }">
                    {{ consentBlocks.mostUploaded }}
                  </div>
                  <div :style="{ color: getPrimaryColor() }">
                    {{ consentBlocks.mostUploadedSite }}
                  </div>
                </div>
                <div v-else class=".thread-consent-ct1 recruitment-doughnut-container align-center no-consent-height">
                  <div class="card-text-title no-data" v-if="this.dataLoaded['visConsentDisposition'] || false">
                    No Data In
                  </div>
                </div>
              </b-card>
            </b-colxx>
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-10">
              <b-card class="custom-card white-bg">
                <b-card-header>
                  <div class="card-text-strong" title="Most Uploaded by Percentage">
                    Most Uploaded by Percentage
                  </div>
                </b-card-header>
                <div v-if="consentBlocks.mostUploaded" class="data-card-center consent-height">
                  <div class="number-text" :style="{ color: getPrimaryColor() }">{{ consentBlocks.mostUploadedPercentage }}%</div>
                  <div :style="{ color: getPrimaryColor() }">
                    {{ consentBlocks.mostUploadedSite }}
                  </div>
                </div>
                <div v-else class=".thread-consent-ct1 recruitment-doughnut-container align-center no-consent-height">
                  <div class="card-text-title no-data" v-if="this.dataLoaded['visConsentDisposition'] || false">
                    No Data In
                  </div>
                </div>
              </b-card>
            </b-colxx>
          </b-row>
        </b-colxx>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import HeaderDropDownFilter from "../form-components/header-drop-down-filter";
import RecruitmentApexBarChartCard from "../containers/recruitment-apex-bar-card";
import ScreenFailureContainer from "../containers/recruitment-fusion-bar-card";
import eConsentDisposition from "../containers/recruitment-fusion-doughnut-card.vue";
import * as EnrollmentService from "../../services/visualization/recruitment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import { PI, STUDY_COORDINATOR } from "@/constants/authRoles";
import ConsentApexChartCard from "../containers/consent-apex-chart-card";
import { tooltipEconsent, tooltipsParticipantQuiz } from "../charts/utils";
import * as Econsent from "../../services/visualization/econsent";
import moment from "moment";
import EnrollmentSum from "../containers/enrollment-sum";
import EnrollmentSumData from "../containers/enrollment-sum-data";
import _get from "lodash/get";
import _ from "lodash";
import { getListCountry, getListSites } from "../../services/visualization/utils";
import * as utils from "../../services/visualization/utils";
import * as commonHelper from "@/components/services/common-helper";

Vue.use(Loading);

export default {
  components: {
    "apex-bar-chart-card": RecruitmentApexBarChartCard,
    ScreenFailureContainer,
    HeaderDropDownFilter,
    ConsentApexChartCard,
    "enrollment-sum": EnrollmentSum,
    "enrollment-sum-data": EnrollmentSumData,
    eConsentDisposition
  },
  props: {
    toggleFeatures: { type: Array, default: () => [] },
    complianceWidgets: { type: Boolean, default: false },
    studyData: { type: Object, default: null }
  },
  data() {
    return {
      leftHeaderTextValue: "Enrollment Dashboard",
      siteRecruitmentRawData: null,
      quizRawData: null,
      quizComprehension: null,
      studyId: null,
      filteredRawDataSiteRecruitment: null,
      screenFailureRawData: null,
      eConsentRawData: null,
      eConsentDispositionData: null,
      fpiDataForViz: null,
      firstDataDataForViz: null,
      failureAggregation: null,
      countryList: [],
      mapSiteCountry: {},
      allSitesList: [],
      sitesSelected: ["all"],
      countrySelected: "all",
      totalFpiSites: 0,
      totalFirstDataSites: 0,
      fastestFpiDateBegin: "",
      fastestFpiDateEnd: "",
      fastestFirstDataDateBegin: "",
      fastestFirstDataDateEnd: "",
      fastestFpiSiteCountry: "",
      fastestFirstDataSiteCountry: "",
      quizAnnotation: null,
      filteredRawDataQuiz: null,
      tooltipsEconsentOptions: null,
      tooltipsParticipantQuizOptions: null,
      isLoading: true,
      zoomGraphValue: "",
      todaysDate: "",
      specificSiteId: null, // you will get specific ID if you're not SystemAdmin
      fromDate: null, //fromDate and toDate is a string value for date filter. Format would be YYYY-MM-DD
      toDate: null,
      topFiveCountries: [],
      topFiveSites: [],
      enrollRawData: {},
      dataPicker: [],
      monthSelected: [],
      dataLoaded: {},
      sitesDetails: [],
      tmpEnrollmentRawData: null,
      consentBlocks: {
        mostEconsent: 0,
        mostUploaded: 0,
        mostEconsentSite: "",
        mostUploadedSite: "",
        mostUploadedPercentage: 0,
        mostEconsentPercentage: 0
      },
      tempSiteArr: [],
      tempCountryArr: [],
      tempMapSiteCountry: {}
    };
  },
  methods: {
    getDateString(date) {
      const d = new Date(date);
      return date
        ? moment(d)
          .format("DD MMM YYYY")
          .toString()
          .toUpperCase()
        : "";
    },
    getDataFromCountry(payload) {
      this.filter("country", payload.isCheckAll ? "all" : payload.checked);
    },
    getDataFromSite(payload) {
      this.filter("site", payload.isCheckAll ? "all" : payload.checked);
    },
    getRangeMonth(payload) {
      this.filter("date", payload);
    },
    filterSitesFromCountries(countries) {
      const filteredSites = [];
      countries.map(country => {
        if(this.allEnrollmentData && this.allEnrollmentData[country]){
          filteredSites.push(Object.keys(this.allEnrollmentData[country]));
        }
      });
      return [].concat.apply([], filteredSites);
    },
    async filter(triggerBy, filterValue) {
      this.filteredRawDataSiteRecruitment = this.siteRecruitmentRawData;
      this.filteredRawDataQuiz = this.quizRawData;
      const updatedVisualizationChart = {};
      updatedVisualizationChart.labels = [];
      updatedVisualizationChart.datasets = [];
      switch (triggerBy) {
        case "country":
          this.countrySelected = filterValue;
          if (filterValue === "all" || (filterValue.length > 0 && filterValue[0].toLowerCase() === "all")) {
            this.sitesSelected = this.allSitesList;
            this.filteredRawDataSiteRecruitment = JSON.parse(JSON.stringify(this.siteRecruitmentRawData)); //deep clone
            this.filteredRawDataQuiz = JSON.parse(JSON.stringify(this.quizRawData)); //deep clone
            this.countrySelected = "all";
            await this.callApi(true, triggerBy);
          } else {
            this.filteredRawDataSiteRecruitment = {};
            this.filteredRawDataQuiz = {};
            let filteredSites = this.filterSitesFromCountries(filterValue);
            filterValue === "all" &&
            this.countryList.forEach(country => {
              if (this.siteRecruitmentRawData[country]) {
                filteredSites = filteredSites.concat(Object.keys(this.siteRecruitmentRawData[country]));
                this.filteredRawDataSiteRecruitment[country] = this.siteRecruitmentRawData[country];
                if (this.quizRawData && this.quizRawData[country]) {
                  this.filteredRawDataQuiz[country] = this.quizRawData[country];
                }
              }
            });
            filterValue !== "all" &&
            filterValue.forEach(country => {
              if (this.siteRecruitmentRawData && this.siteRecruitmentRawData[country]) {
                filteredSites = filteredSites.concat(Object.keys(this.siteRecruitmentRawData[country]));
                this.filteredRawDataSiteRecruitment[country] = this.siteRecruitmentRawData[country];
              }
              if (this.quizRawData && this.quizRawData[country]) {
                this.filteredRawDataQuiz[country] = this.quizRawData[country];
              }
            });
            this.sitesSelected = [...new Set(filteredSites)];
            this.enrollRawData = await this.getVisOverallEnrollementData(triggerBy);
            if (this.screenFailureRawData) {
              this.failureAggregation = await EnrollmentService.wrangleFailureAggregation(this.screenFailureRawData, this.countrySelected, this.sitesSelected);
            }
            if (this.eConsentRawData) {
              this.eConsentDispositionData = await EnrollmentService.wrangleConsentDisposition(this.eConsentRawData, this.countrySelected, this.sitesSelected);
              this.consentBlocks = this.eConsentDispositionData.consentBlocks;
            }
          }
          break;
        case "site":
          const filteredCountries = [];
          this.filteredRawDataSiteRecruitment = {};
          this.filteredRawDataQuiz = {};
          if (filterValue === "all") {
            this.filteredRawDataSiteRecruitment = this.siteRecruitmentRawData;
            this.filteredRawDataQuiz = this.quizRawData;
            this.countrySelected = "all";
            this.sitesSelected = filterValue;
            await this.callApi(true, triggerBy);
          } else {
            filterValue.forEach(siteName => {
              const countryName = this.mapSiteCountry[siteName];
              if (!this.filteredRawDataSiteRecruitment[countryName]) {
                this.filteredRawDataSiteRecruitment[countryName] = {};
              }
              if (this.siteRecruitmentRawData && this.siteRecruitmentRawData[countryName] && this.siteRecruitmentRawData[countryName][siteName]) {
                this.filteredRawDataSiteRecruitment[countryName][siteName] = this.siteRecruitmentRawData[countryName][siteName];
              }
              if (this.quizRawData && this.filteredRawDataQuiz && !this.filteredRawDataQuiz[countryName] && this.quizRawData[countryName]) {
                this.filteredRawDataQuiz[countryName] = {};
              }
              if (this.quizRawData && this.quizRawData[countryName]) {
                this.filteredRawDataQuiz[countryName][siteName] = this.quizRawData[countryName][siteName];
              }
              if (filteredCountries.indexOf(countryName) == -1) {
                filteredCountries.push(countryName);
              }
              this.countrySelected = filteredCountries;
            });
            this.sitesSelected = [...new Set(filterValue)];
            if (filterValue.length) {
              this.failureAggregation = await EnrollmentService.wrangleFailureAggregation(this.screenFailureRawData, this.countrySelected, this.sitesSelected);
              this.eConsentDispositionData = await EnrollmentService.wrangleConsentDisposition(this.eConsentRawData, this.countrySelected, this.sitesSelected);
            } else {
              this.failureAggregation = await EnrollmentService.wrangleFailureAggregation(this.screenFailureRawData, [], this.sitesSelected);
              this.eConsentDispositionData = await EnrollmentService.wrangleConsentDisposition(this.eConsentRawData, [], this.sitesSelected);
            }
            this.consentBlocks = this.eConsentDispositionData.consentBlocks;

            this.enrollRawData = await this.getVisOverallEnrollementData(triggerBy);
          }
          break;
        case "date": {
          this.monthSelected = filterValue;
          //TODO THIS IS ONLY for TESTING. DELETE AFTER DATE FILTER CALENDAR IMPLEMENTED
          this.fromDate = this.fromDate = filterValue[0].value;
          this.toDate = this.toDate = filterValue[1].value;

          this.quizRawData = await this.getVisualizationRawDataQuiz(triggerBy); //other vizs doesnt need to hit backend to filter date. But quiz viz  need to
          this.filteredRawDataQuiz = this.quizRawData;
          this.eConsentRawData = await this.getVisConsentDispositionRawData(triggerBy);
          this.screenFailureRawData = await this.getVisScreenFailureRawData(triggerBy);
          await this.callApi();
          if (this.sitesSelected && this.sitesSelected[0] !== "all" && this.sitesSelected !== "all") {
            const filteredCountries = [];
            this.filteredRawDataSiteRecruitment = {};
            this.filteredRawDataQuiz = {};
            this.sitesSelected.forEach(siteName => {
              const countryName = this.mapSiteCountry[siteName];
              if (!this.filteredRawDataSiteRecruitment[countryName]) {
                this.filteredRawDataSiteRecruitment[countryName] = {};
              }
              this.filteredRawDataSiteRecruitment[countryName][siteName] = this.siteRecruitmentRawData[countryName][siteName];
              if (!this.filteredRawDataQuiz[countryName]) {
                this.filteredRawDataQuiz[countryName] = {};
              }
              if (this.quizRawData[countryName]) {
                this.filteredRawDataQuiz[countryName][siteName] = this.quizRawData[countryName][siteName];
              }
              if (filteredCountries.indexOf(countryName) == -1) {
                filteredCountries.push(countryName);
              }
              this.countrySelected = filteredCountries;
            });
            if (this.screenFailureRawData) {
              this.failureAggregation = await EnrollmentService.wrangleFailureAggregation(this.screenFailureRawData, this.countrySelected, this.sitesSelected);
            }
            if (this.eConsentRawData) {
              this.eConsentDispositionData = await EnrollmentService.wrangleConsentDisposition(this.eConsentRawData, this.countrySelected, this.sitesSelected);
              this.consentBlocks = this.eConsentDispositionData.consentBlocks;
            }
          } else {
            if (this.screenFailureRawData) {
              this.failureAggregation = await EnrollmentService.wrangleFailureAggregation(this.screenFailureRawData, this.countryList, this.allSitesList);
            }
            if (this.eConsentRawData) {
              this.eConsentDispositionData = await EnrollmentService.wrangleConsentDisposition(this.eConsentRawData, this.countryList, this.allSitesList);
              this.consentBlocks = this.eConsentDispositionData.consentBlocks;
            }
          }
          this.isLoading = false;
          break;
        }
      }
      this.generateParticipantEnrollData();
      // Display only if study is really selected
      if (this.siteRecruitmentRawData != null) {
        // Do 1st pass filter

        // Then update for both timeline and barchart components
        const isSiteStaff = this.specificSiteId.length > 0;
        this.fpiDataForViz = await EnrollmentService.wrangleSiteRecruitmentData(this.filteredRawDataSiteRecruitment, "fpi", this.fromDate, this.toDate, isSiteStaff);
        this.firstDataDataForViz = await EnrollmentService.wrangleSiteRecruitmentData(this.filteredRawDataSiteRecruitment, "firstData", this.fromDate, this.toDate, isSiteStaff);
        this.quizComprehension = await EnrollmentService.wrangleQuizComprehensionData(this.filteredRawDataQuiz, isSiteStaff);

        // Update summary cards
        const stats = await EnrollmentService.calculateRecruitmentStats(this.filteredRawDataSiteRecruitment, this.fromDate, this.toDate);
        this.fastestFpiDateBegin = this.getDateString(stats.fastestFpi.activeDate);
        this.fastestFpiDateEnd = this.getDateString(stats.fastestFpi.date);
        this.fastestFpiSiteCountry = stats.fastestFpi.site
          ? {
            site: stats.fastestFpi.site,
            country: stats.fastestFpi.country
          }
          : null;
        this.fastestFirstDataDateBegin = this.getDateString(stats.fastestFirstData.activeDate);
        this.fastestFirstDataDateEnd = this.getDateString(stats.fastestFirstData.date);
        this.fastestFirstDataSiteCountry = stats.fastestFirstData.site
          ? {
            site: stats.fastestFirstData.site,
            country: stats.fastestFirstData.country
          }
          : null;

        this.totalFpiSites = stats.totalFpi;
        this.totalFirstDataSites = stats.totalFirstData;
      } else {
        this.fpiDataForViz = null;
        this.firstDataDataForViz = null;
      }
    },
    generateParticipantEnrollData() {
      // Set top 5 countries
      if(this.enrollRawData){
        this.topFiveCountries = _.filter(this.enrollRawData.topFiveCountries, country => {
        return this.countrySelected === "all" || this.countrySelected.indexOf(country.countryName) >= 0;
        });
        // Set top 5 sites
        this.topFiveSites = _.filter(this.enrollRawData.topFiveSites, site => {
          return this.sitesSelected === "all" || this.sitesSelected[0] === "all" || this.sitesSelected.indexOf(site.siteName) >= 0;
        });
      }
    },
    getRecruitmentVisualizationRawData(recruitmentType = null, triggerBy) {
      this.dataLoaded["visualizationRawData"] = false;
      let response = null;
      const params = {
        studyId: this.studyId
      };
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      if (this.fromDate && triggerBy == "date") {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }
      if (recruitmentType) {
        params.recruitmentType = recruitmentType;
      }

      if (this.recruitmentData && this.recruitmentData.body && this.checkCurrentSiteOrStudy) {
        let result = this.recruitmentData.body;
        if (result.data && "locations" in result.data) {
          response = result.data.locations;
          this.setRecruitmentVisualizationRawData(response)
        }
      } else {
        this.$api.getRecruitmentVisData(params).then(data => {
        if (data.ok) {
          let result = data.body;
          this.$store.dispatch("saveRecruitementData", data);
          this.$store.dispatch("saveStudyId", this.studyId);
          if (result.data !== {}) {
            if ("locations" in result.data) {
              response = result.data.locations;
              this.setRecruitmentVisualizationRawData(response)
            }
          }
        }
        })
      }
      this.dataLoaded["visualizationRawData"] = true;
      return response;
    },
    setRecruitmentVisualizationRawData(response) {
      if (response) {
        this.siteRecruitmentRawData = response
        this.tempCountryArr = this.tempCountryArr.concat(EnrollmentService.getCountryList(this.siteRecruitmentRawData));
        const { allSites: allSitesRecruitment, mapSiteCountry: mapSiteCountryRecruitment } = EnrollmentService.getAllSites(this.siteRecruitmentRawData);
        this.tempSiteArr = this.tempSiteArr.concat(allSitesRecruitment);
        this.tempMapSiteCountry = {
          ...this.tempMapSiteCountry,
          ...mapSiteCountryRecruitment
        };
      }
    },
    getVisualizationRawDataQuiz(triggerBy) {
      this.dataLoaded["visualizationRawDataQuiz"] = false;
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      if (this.fromDate && triggerBy == "date") {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }

      if (this.quizData && this.quizData.body && this.checkCurrentSiteOrStudy) {
        let result = this.quizData.body;
        if (result.data && "locations" in result.data) {
          response = result.data.locations;
          this.setVisualizationRawDataQuiz(response);
          this.getQuizData(response);
        }
      } else {
        this.$api.getQuizVisData(params).then(data => {
          if (data.ok) {
            let result = data.body;
            this.$store.dispatch("saveQuizData", data);
            this.$store.dispatch("saveStudyId", this.studyId);
            if (result.data !== {}) {
              if ("locations" in result.data) {
                response = result.data.locations;
                this.setVisualizationRawDataQuiz(response);
                this.getQuizData(response);
              }
            }
          }
        });
      }
      this.isLoading = false;
      this.dataLoaded["visualizationRawDataQuiz"] = true;
      return response;
    },
    setVisualizationRawDataQuiz(response) {
      this.quizRawData = response
      if (this.quizRawData) {
        this.tempCountryArr = this.tempCountryArr.concat(EnrollmentService.getCountryList(this.quizRawData));
        const { allSites: allSitesQuiz, mapSiteCountry: mapSiteCountryQuiz } = EnrollmentService.getAllSites(this.quizRawData);
        this.tempSiteArr = this.tempSiteArr.concat(allSitesQuiz);
        this.tempMapSiteCountry = { ...this.tempMapSiteCountry, ...mapSiteCountryQuiz };
      }
    },
    getVisOverallEnrollementData(filterBy = null) {
      // this.dataLoaded['overallEnrollmentData'] = false
      this.isLoading = true;

      let response = null;
      let isAllSiteCountrySelected = false;
      const params = {
        studyId: this.studyId
      };
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      if (this.fromDate && filterBy == "date") {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }
      if (filterBy === "country" && !(this.countrySelected[0] === "all" || this.countrySelected === "all")) {
        const countryIds = this.getCountryIds(this.countrySelected);
        params.countryIds = utils.convertArrToString(countryIds);
      } else if (filterBy === "site" && !(this.sitesSelected[0] === "all" || this.sitesSelected === "all")) {
        const siteIds = this.getSiteIds(this.sitesSelected);
        params.siteIds = utils.convertArrToString(siteIds);
      } else {
        isAllSiteCountrySelected = true;
      }

      if (this.enrollmentParticipantData && this.enrollmentParticipantData.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
        let responseBody = this.enrollmentParticipantData.body;
        if(responseBody.data){
          response = responseBody.data;
          this.setVisOverallEnrollmentData(response);
        }
      } else {
        this.$api.getEnrollmentParticipantData(params).then(responseData => {
          if (responseData.ok) {
            const { data } = responseData.body;
            this.$store.dispatch("saveEnrollmentData", responseData);
            this.$store.dispatch("saveStudyId", this.studyId);
            if(isAllSiteCountrySelected){
              let locations = data.locations;
              this.$store.dispatch("saveAllEnrollmentData", locations);
            }
            // TODO: Dont forget to activated after api has been deployed!
            if (data !== {}) {
              response = data;
             this.setVisOverallEnrollmentData(response);
            } else {
              this.isLoading = false;
            }
          }
        });
      }
      this.isLoading = false;
      this.dataLoaded["overallEnrollmentData"] = true;
      return response;
    },
    setVisOverallEnrollmentData(response) {
      this.enrollRawData = response;
      this.tmpEnrollmentRawData = response;
      // Set the locations
      this.locations = _get(response, "locations", null);
      // Set top 5 countries
      this.topFiveCountries = response.topFiveCountries;
      this.generateParticipantEnrollData();

      // Set list countries under study
      this.tempCountryArr = this.tempCountryArr.concat(getListCountry(this.locations));
      this.tempCountryArr.splice(this.tempCountryArr.indexOf("All"), 1);
      // Set list site under study and country
      const { allSites: allSitesOverallSum, mapSiteCountry: mapSiteCountryOverallSum } = getListSites(this.locations);
      this.tempSiteArr = this.tempSiteArr.concat(allSitesOverallSum);
      this.tempMapSiteCountry = {
        ...this.tempMapSiteCountry,
        ...mapSiteCountryOverallSum
      };
    },
    getVisScreenFailureRawData(triggerBy) {
      this.dataLoaded["visScreenFailure"] = false;
      this.isLoading = true;
      const body = {};
      let response = null;
      const params = {
        studyId: this.studyId
      };
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        body.siteId = this.specificSiteId[0];
      }
      if (this.fromDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }

      if (this.topScreenFailuaresReason && this.topScreenFailuaresReason.body && this.checkCurrentSiteOrStudy) {
        let responseBody = this.topScreenFailuaresReason.body;
        if(responseBody.data){
          response = responseBody.data;
          this.setVisScreenFailureRawData(response)
        }
      } else {
        this.$api.getTopReasonsForScreenFailure(params, body).then(responseData => {
          if (responseData.ok) {
          const { data } = responseData.body;
          this.$store.dispatch("saveTopScreenFailuareReasons", responseData);
          this.$store.dispatch("saveStudyId", this.studyId);
          // TODO: Dont forget to activated after api has been deployed!
          if (data !== {}) {
            response = data;
            this.setVisScreenFailureRawData(response)
            }
          } else {
            this.isLoading = false;
          }
        })
      }
      this.isLoading = false;
      this.dataLoaded["visScreenFailure"] = true;
      return response;
    },
    async setVisScreenFailureRawData(response) {
      this.screenFailureRawData = response
      if (this.screenFailureRawData) {
        const CountryArr = EnrollmentService.getCountryList(this.screenFailureRawData);
        this.tempCountryArr = this.tempCountryArr.concat(CountryArr);
        const {
          allSites: allSitesFailureReason,
          mapSiteCountry: mapSiteCountryFailureReason
        } = EnrollmentService.getAllSites(this.screenFailureRawData);
        this.tempSiteArr = this.tempSiteArr.concat(allSitesFailureReason);
        this.tempMapSiteCountry = {
          ...this.tempMapSiteCountry,
          ...mapSiteCountryFailureReason
        };
        this.failureAggregation = await EnrollmentService.wrangleFailureAggregation(this.screenFailureRawData, CountryArr, allSitesFailureReason);
      }
    },
    getVisConsentDispositionRawData(triggerBy) {
      this.dataLoaded["visConsentDisposition"] = false;
      this.isLoading = true;
      const body = {};
      let response = null;
      const params = {
        studyId: this.studyId
      };
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        body.siteId = this.specificSiteId[0];
      }
      if (this.fromDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }

      if (this.eConsentUploadedData && this.eConsentUploadedData.body && this.checkCurrentSiteOrStudy) {
        let responseBody = this.eConsentUploadedData.body;
        if(responseBody.data){
          response = responseBody.data;
          this.setVisConsentDispositionRawData(response)
        }
      } else {
        this.$api.getConsentDispositionVisData(params, body).then(responseData => {
          if (responseData.ok) {
            const { data } = responseData.body;
            this.$store.dispatch("saveEconsentUploadedData", responseData);
            this.$store.dispatch("saveStudyId", this.studyId);
            // TODO: Dont forget to activated after api has been deployed!
            if (data !== {}) {
              response = data;
              this.setVisConsentDispositionRawData(response)
            } else {
              this.isLoading = false;
            }
          }
        });
      }
      this.isLoading = false;
      this.dataLoaded["visConsentDisposition"] = true;
      return response;
    },
    async setVisConsentDispositionRawData(response) {
      this.eConsentRawData = response
      if (this.eConsentRawData) {
        const CountryArr = EnrollmentService.getCountryList(this.eConsentRawData);
        this.tempCountryArr = this.tempCountryArr.concat(CountryArr);
        const { allSites: allSitesConsentSignedStatus, mapSiteCountry: mapSiteCountryConsentSignedStatus } = EnrollmentService.getAllSites(this.eConsentRawData);
        this.tempSiteArr = this.tempSiteArr.concat(allSitesConsentSignedStatus);
        this.tempMapSiteCountry = {
          ...this.tempMapSiteCountry,
          ...mapSiteCountryConsentSignedStatus
        };
        this.eConsentDispositionData = await EnrollmentService.wrangleConsentDisposition(this.eConsentRawData, CountryArr, allSitesConsentSignedStatus);
        this.consentBlocks = this.eConsentDispositionData.consentBlocks;
      }
    },
    prepareDatePicker() {
      const d = new Date();
      this.todaysDate = moment.utc(d).format("DD MMM YYYY");
      const studyData = this.studyData;
      const studyStartDate = studyData.studyStartDate;
      const datePicker = [];
      for (let m = moment(studyStartDate); m.diff(moment(), "months") <= 0; m.add(1, "months")) {
        datePicker.push(m.format("MMM YYYY"));
      }
      this.dataPicker = datePicker;
      const firstMonth = this.dataPicker[0];
      const lastMonth = this.dataPicker[this.dataPicker.length - 1];

      this.fromDate = moment(`01 ${firstMonth}`, "DD MMM YYYY")
        .startOf("month")
        .format("YYYY-MM-DD");
      this.toDate = moment(`01 ${lastMonth}`, "DD MMM YYYY")
        .endOf("month")
        .format("YYYY-MM-DD");

      this.monthSelected = [firstMonth, lastMonth];
    },

    callApi(turnOffGlobalLoader = false, triggerBy) {
      this.getVisOverallEnrollementData(triggerBy);
      this.getRecruitmentVisualizationRawData("fpi", triggerBy);
      this.getVisualizationRawDataQuiz(triggerBy);
      this.getVisConsentDispositionRawData(triggerBy);
      // set screen failure reasons
      this.getVisScreenFailureRawData(triggerBy);
      this.setSiteAndCountryList();

      const quizCompleted = Econsent.getAverageParticipantStatus(this.quizRawData, "quizQompletion");
      const quizIncomplete = Econsent.getAverageParticipantStatus(this.quizRawData, "quizIncomplete");

      this.quizAnnotation = {
        verticalValue: quizIncomplete,
        verticalContent: "Average Incomplete Quiz",
        horizontalValue: quizCompleted,
        horizontalContent: "Average Completed Quiz"
      };

      // ================================
      // |  Get data Econsent vs Upload |
      // \=============================|
      this.tooltipsEconsentOptions = tooltipEconsent; /* Set options for tooltips callback */
      this.tooltipsParticipantQuizOptions = tooltipsParticipantQuiz; /* Set options for tooltips callback */

      if (turnOffGlobalLoader) {
        this.turnOffGlobalLoader();
      }
    },

    turnOffGlobalLoader() {
      const query = Object.assign({}, this.$route.query);
      delete query.automatic_off_loader;
      this.$router.replace({ query });
      this.$store.commit("SHOW_LOADER", false);
    },
    getSiteDetails() {
      if (this.sitesData && this.sitesData.length > 0 && this.checkCurrentSiteOrStudy) {
        this.sitesDetails = this.sitesData;
      } else {
        let response = [];
        this.$api.getSitesFact(this.studyId).then(responseData=>{
          if (responseData.ok) {
            response = _get(responseData, "body", null);
            this.$store.dispatch("saveSitesData", response);
            this.$store.dispatch("saveStudyId", this.studyId);
            commonHelper.setSiteId();
            this.sitesDetails = response;
          }
        });
      }
    },
    getCountryIds(countryNames) {
      let countryIds = [];
      countryNames.map(countryName => {
        this.sitesDetails.forEach(site => {
          if (site.countryList[0].countryName === countryName) {
            countryIds.push(site.countryList[0].countryId);
          }
        });
      });
      countryIds = [...new Set(countryIds)];
      return countryIds;
    },
    getSiteIds(siteNames) {
      const siteIds = [];
      siteNames.map(siteName => {
        this.sitesDetails.forEach(site => {
          if (site.name === siteName) {
            siteIds.push(site.id);
          }
        });
      });
      return siteIds;
    },
    getPrimaryColor() {
      return utils.getColorPalette("light").split(",")[0];
    },
    async getQuizData(quizData){
      const isSiteStaff = this.specificSiteId.length > 0;
      this.quizComprehension = await EnrollmentService.wrangleQuizComprehensionData(quizData, isSiteStaff);
    },
    setSiteAndCountryList(){
      const uniqueCountryList = new Set(this.tempCountryArr);
      this.countryList = _.orderBy(Array.from(uniqueCountryList), [country => country.toLowerCase()]);

      const uniqueSiteList = new Set(this.tempSiteArr);
      this.allSitesList = _.orderBy(Array.from(uniqueSiteList), [site => site.toLowerCase()]);

      this.mapSiteCountry = { ...this.tempMapSiteCountry };
    }
  },
  computed: {
    ...mapGetters(["user", "sitesData", "studyIdValue", "enrollmentParticipantData", "eConsentUploadedData", "topScreenFailuaresReason", "quizData", "recruitmentData", "allEnrollmentData", "selectedSiteId"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    getSiteId() {
      return localStorage.getItem("selectedSite");
    },
    isSiteRole() {
      return commonHelper.isSiteUser(this.user.userRole);
    },
    checkCurrentSiteOrStudy() {
      return this.studyIdValue === this.studyId && (!this.isSiteRole || (this.isSiteRole && this.getSiteId === this.selectedSiteId));
    },
    getActivateScreenFailure(){
      return this.studyData.participantPortal;
    }
  },
  watch: {
    siteRecruitmentRawData: {
      handler(val){
        if(val){
          this.filter("study", this.studySelected);
        }
      }
    },
    filteredRawDataQuiz: {
      deep: true,
      handler(value){
        if(value){
          this.getQuizData(value);
        }
      }
    },
    tempCountryArr: function(val) {
      if(this.sitesSelected[0] == "all" || this.sitesSelected == "all"){
        const uniqueCountryList = new Set(val);
        this.countryList = _.orderBy(Array.from(uniqueCountryList), [country => country.toLowerCase()]);
        this.setSiteAndCountryList();
      }
    },
    tempSiteArr: function(val) {
      if(this.sitesSelected[0] == "all" || this.sitesSelected == "all"){
        const uniqueSiteList = new Set(val);
        this.allSitesList = _.orderBy(Array.from(uniqueSiteList), [site => site.toLowerCase()]);
        this.setSiteAndCountryList();
      }
    },
  },
  mounted() {
    try {
      this.$router.push({ query: { automatic_off_loader: false } });
      this.studyId = this.$route.params.studyId;
      this.prepareDatePicker();

      this.specificSiteId = _get(this.user, "siteIds", []);
      this.getSiteDetails();
      this.callApi(true, "mounted");
    } catch (error) {
      this.turnOffGlobalLoader();
    }
  }
};
</script>

<style scoped>
.small-card-text {
  width: 95px;
}

span {
  display: inline-block;
}

.consent-height {
  min-height: 117px;
}

.no-consent-height {
  min-height: 100px;
}
</style>
